import React from 'react';
import Status from './Status';

export default () => <Status code={404}>Not found</Status>;
